import styled from 'styled-components';

import { BackgroundElement } from '@/core/interfaces/common';

export const ResetFormButton = styled.button`
  display: block;
  border: 0;
  background-color: inherit;
  cursor: pointer;
`;

export const ResetForm = styled.span<BackgroundElement>`
  color: ${props => (props.textcolor)};
  font-weight: 700;
`;
